<template>
  <scroll-center-dialog v-model="open" :loading="loading" :apply-text="'Отправить'" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <div class="field_label__text">Тема:</div>
    <v-text-field
        class="dialog__fields"
        color="#3254B9"
        base-color="#313743"
        variant="solo"
        v-model="feedback.theme"
        :loading="loading"
        :error="hasError('theme')"
        :error-messages="getError('theme')"
    >
      <template v-slot:label></template>
    </v-text-field>
    <div class="field_label__text">Текст:</div>
    <v-textarea
        class="dialog__fields"
        color="#3254B9"
        base-color="#313743"
        variant="solo"
        rows="5"
        max-rows="15"
        :auto-grow="true"
        v-model="feedback.text"
        :loading="loading"
        :error="hasError('text')"
        :error-messages="getError('text')"
    >
      <template v-slot:label></template>
    </v-textarea>
    <div class="field_label__text">Прикрепите файлы (.pdf, .png, .jpeg или .docx):</div>
    <div class="feedback_file__container">
      <v-file-input
          class="feedback_file__input"
          label="File input"
          variant="solo"
          prepend-icon=""
          color="#3254B9"
          base-color="#313743"
          accept=".pdf, .png, .jpeg, .doc, .docx"
          :multiple="true"
          v-model="feedback.files"
          :loading="loading"
          :error="hasError('files')"
          :error-messages="getError('files')"
      >
        <template v-slot:label>
          <div class="d-flex flex-wrap">
            <v-row justify="center" class="feedback_file__input_row" no-gutters>
              <v-icon :size="$vuetify.display.width >= 1280 ? 70 : 35" style="transform: rotate(45deg)">attach_file</v-icon>
            </v-row>
          </div>
        </template>
      </v-file-input>
    </div>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog"
import { mapActions } from "vuex"

export default {
  name: "SendFeedbackDialog",
  props: {
    value: Boolean,
  },
  components: {
    ScrollCenterDialog,
  },
  mixins: [FormErrorsMixin],
  data () {
    return {
      open: false,
      loading: false,
      feedback: {
        theme: '',
        text: '',
        files: []
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open: {
      immediate: true,
      handler () {
        this.$emit('input', this.open)
      }
    }
  },
  computed: {
    form_title () {
      return this.$vuetify.display.width < 370 ? 'Обращение' : 'Отправить обращение'
    },
  },
  methods: {
    ...mapActions({
      createFeedback: 'personal_account/feedbacks/createFeedback'
    }),
    save () {
      this.loading = true

      const formData = new FormData()
      formData.append('theme', this.feedback.theme)
      formData.append('text', this.feedback.text)

      if (typeof this.feedback.files === 'object' && this.feedback.files.length > 0) {
        for (const index in this.feedback.files) {
          formData.append('files', this.feedback.files[index], this.feedback.files[index].name)
        }
      }

      this.createFeedback({
        data: formData,
        finalizer: () => {
          this.$emit('save')
          this.loading = false
        },
        catcher: (val) => {
          this.mapErrors(val)
          this.loading = false
        },
      })
    },
    close () {
      this.$emit('close')
    },
  },
  created () {}
}
</script>

<style scoped lang="scss">
.dialog__fields {
  margin-bottom: 5px;
}

.field_label__text {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #3254B9;
}

.feedback_file__container {
  padding: 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}

.feedback_file__input {
  margin: 0 auto;
  width: 100%;
}

.feedback_file_label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;

  color: #313743;
}

.feedback_file__input_row {
  width: 100%;
}

.feedback_file__container > .v-input > .v-input__control > .v-field--active {
  .feedback_file__input_row {
    &:first-child {
      display: none;
    }
  }

  .feedback_file_label__text {
    color: currentColor;
  }
}

@media screen and (max-width: 768px) {
  .field_label__text {
    font-size: 12px;
    line-height: 15px;
  }
}
</style>
